import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { Box } from '@cp/ds/src/components/box';
import { Stack } from '@cp/ds/src/components/stack';
import { Trademark } from '@cp/ds/src/components/trademark';
import { Typography } from '@cp/ds/src/components/typography';
import { LogoIcon } from '@cp/ds/src/icons/logo';
import React from 'react';
import QrCodeSvg from '../../../../../../../assets/shapes/mobileApplicationQrCode.svg';
import MobileScreenSvg from '../../../../../../../assets/shapes/mobileScreen.svg';
import { WIDTH_QR_CODE_SECTION } from '../const';

const QrCodeSection: React.FC = () => {
  const theme = useTheme();
  return (
    <Stack
      alignItems="center"
      borderRadius={theme.borderRadius.normal}
      justifyContent="center"
      overflow="hidden"
      p={1.8}
      position="absolute"
      right={0}
      sx={{ backgroundColor: 'brand gray hover' }}
      top={0}
      width={WIDTH_QR_CODE_SECTION}
    >
      <MobileScreenSvg color="white" width="100%" />
      <Stack alignItems="center" color="brand gray" height={0.5} justifyContent="flex-end" position="absolute" top={0} width={1}>
        <QrCodeSvg color="brand gray hover" style={{ width: 'auto', maxHeight: '100%', paddingTop: '5%' }} />
        <Typography component="span" sx={{ mt: 2.5, mb: 1.8, px: 2, typography: { md: 'body bold', lg: 'button' }, textAlign: 'center' }}>
          Наведите камеру телефона, чтобы скачать приложение
        </Typography>
        <Trademark size={2} />
      </Stack>
      <Stack alignItems="center" bottom={0} height={0.5} justifyContent="center" position="absolute">
        <Box
          sx={{
            backgroundColor: 'brand gray',
            lineHeight: 0,
            p: 1.5,
            borderRadius: `${theme.borderRadius.small}px`,
            boxShadow: '0px 5px 7px 0px #bfbfbf',
          }}
        >
          <LogoIcon color="brand pink" fontSize="large" />
        </Box>
      </Stack>
    </Stack>
  );
};

export default QrCodeSection;
